import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import "./index.css";
import { Toast } from "antd-mobile";
import { useState } from "react";

export default function CenterPage({ info, userInfo, sendTx }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const type = 2;
  const [num, setNum] = useState("");
  const [bank, setbank] = useState("");
  const [name, setname] = useState("");
  const [bankNo, setbankNo] = useState("");
  const [bankCode, setbankCode] = useState("");
  const [routeCode, setrouteCode] = useState("");
  const [swift, setswift] = useState("");
  const [bankAddress, setbankAddress] = useState("");
  const [branchCode, setbranchCode] = useState("");
  const [remark, setremark] = useState("");

  const inputClasses = "w-full bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3 text-neutral-100 placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-primary transition duration-200";
  const labelClasses = "block text-sm font-medium text-neutral-400 mb-1";

  return (
    <div className="min-h-screen bg-neutral-900 p-4 md:p-6">
      <div className="max-w-2xl mx-auto bg-neutral-800/50 rounded-xl backdrop-blur-sm p-6">
        <div className="space-y-6">
          {/* 银行信息表单 */}
          <div className="space-y-4">
            <div>
              <label htmlFor="bank-name" className={labelClasses}>
                {translate(getText("银行名称"))}*
              </label>
              <input
                type="text"
                id="bank-name"
                className={inputClasses}
                value={bank}
                onChange={(e) => setbank(e.target.value)}
                placeholder={translate(getText("银行名称"))}
              />
            </div>

            <div>
              <label htmlFor="account-name" className={labelClasses}>
                {translate(getText("收款人姓名"))}*
              </label>
              <input
                type="text"
                id="account-name"
                className={inputClasses}
                value={name}
                onChange={(e) => setname(e.target.value)}
                placeholder={translate(getText("收款人姓名"))}
              />
            </div>

            <div>
              <label htmlFor="bank-account" className={labelClasses}>
                {translate(getText("银行卡号"))}*
              </label>
              <input
                type="text"
                id="bank-account"
                className={inputClasses}
                value={bankNo}
                onChange={(e) => setbankNo(e.target.value)}
                placeholder={translate(getText("银行卡号"))}
              />
            </div>

            <div>
              <label htmlFor="bank-code" className={labelClasses}>
                {translate(getText("银行代码"))}
              </label>
              <input
                type="text"
                id="bank-code"
                className={inputClasses}
                value={bankCode}
                onChange={(e) => setbankCode(e.target.value)}
                placeholder={translate(getText("银行代码"))}
              />
            </div>

            <div>
              <label htmlFor="swift-code" className={labelClasses}>
                {translate(getText("SWIFT代码"))}
              </label>
              <input
                type="text"
                id="swift-code"
                className={inputClasses}
                value={swift}
                onChange={(e) => setswift(e.target.value)}
                placeholder={translate(getText("SWIFT代码"))}
              />
            </div>

            <div>
              <label htmlFor="bank-address" className={labelClasses}>
                {translate(getText("银行地址"))}
              </label>
              <input
                type="text"
                id="bank-address"
                className={inputClasses}
                value={bankAddress}
                onChange={(e) => setbankAddress(e.target.value)}
                placeholder={translate(getText("银行地址"))}
              />
            </div>

            <div>
              <label htmlFor="remark" className={labelClasses}>
                {translate(getText("备注信息"))}
              </label>
              <textarea
                id="remark"
                className={`${inputClasses} min-h-[80px] resize-none`}
                value={remark}
                onChange={(e) => setremark(e.target.value)}
                placeholder={translate(getText("备注信息"))}
              />
            </div>

            {/* 提示信息 */}
            <div className="flex items-start space-x-2 p-4 bg-neutral-800/50 rounded-lg">
              <img
                src="/img/icon_alert_line.bfdebf88.svg"
                alt=""
                className="w-5 h-5 mt-0.5"
              />
              <span className="text-sm text-neutral-400">
                {translate(getText("提示"))}:
                {translate(
                  getText("請在備註信息內填寫收款銀行的必要信息以及標註信息的題目")
                )}
              </span>
            </div>
          </div>

          {/* 提款金额 */}
          <div className="mt-8 space-y-6">
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <label className="text-neutral-400 text-sm font-medium">
                  {translate(getText("提款数量"))}
                </label>
                <span className="text-neutral-400 text-sm">
                  {translate(getText("可用數量:"))} {userInfo?.usdt} USDT
                </span>
              </div>
              <div className="relative">
                <input
                  type="text"
                  inputMode="decimal"
                  className={`${inputClasses} pr-20`}
                  value={num}
                  onChange={(e) => setNum(e.target.value)}
                  placeholder={translate(getText("請填寫數量"))}
                />
                <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center space-x-2">
                  <span className="text-neutral-400">USDT</span>
                  <button
                    onClick={() => setNum(userInfo?.usdt)}
                    className="px-2 py-1 text-xs text-primary hover:text-primary-light transition-colors"
                  >
                    {translate(getText("全部"))}
                  </button>
                </div>
              </div>
            </div>

            {/* 提交按钮 */}
            <button
              onClick={() => {
                sendTx({
                  type,
                  num,
                  bank,
                  name,
                  bankNo,
                  bankCode,
                  routeCode,
                  swift,
                  bankAddress,
                  branchCode,
                  remark,
                });
              }}
              className="w-full bg-gradient-primary hover:opacity-90 text-white font-medium py-4 rounded-lg transition duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
            >
              {translate(getText("提交"))}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
